import React from "react";
import { Outlet } from "react-router-dom";
import CallWaiterBell from "@/components/CallWaiterBell";

// Shared layout for the public customer flow. Renders the outlet's page
// content plus a fixed, always-visible "Chiama Cameriere" bell in the top-
// right corner. Mounted once by the router so the component (and its
// countdown/cart subscription) survives navigation between customer pages.
// Staff/admin routes are NOT wrapped by this layout, so the bell never
// appears there.
export default function CustomerLayout() {
  return (
    <>
      <Outlet />
      <div
        data-testid="global-waiter-bell"
        className="fixed top-4 right-4 z-40"
      >
        <CallWaiterBell />
      </div>
    </>
  );
}
